export default __webpack_public_path__ + "static/media/coach_guideme_softclix_lancingkit_lancets200_strips250_cuff_gray@1x.4eea105b.webp";